export default __webpack_public_path__ + "static/media/particles-web-theme3.4b166df1.svg";